import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Navigation = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <ul className="list-none space-y-4" data-id="element-642" data-mp="2optx1v6lzcdq">
      <li className="flex" data-id="element-643" data-mp="2jppi49lcmppm">
        <span className="mr-2" data-id="element-644" data-mp="2jqh1mm1o8wzj">↑</span>
        <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-645" data-mp="3hcoe0i47vtmg">
          About
        </Link>
      </li>
      <li className="flex" data-id="element-646" data-mp="32n0enmflj51d">
        <span className="mr-2" data-id="element-647" data-mp="32lpb9nq2bzas">↑</span>
        <Link to="/photographs" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-648" data-mp="3ybcc5349ae3">
          Photography
        </Link>
      </li>
      <li className="flex" data-id="element-649" data-mp="25a1alht97m2o">
        <span className="mr-2" data-id="element-650" data-mp="1qly509j4icee">↑</span>
        <Link to="/writing" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-651" data-mp="1qkwwabpky1zu">
          Editorial
        </Link>
      </li>
      <li className="flex" data-id="element-652" data-mp="1lkimao4f4hz6">
        <span className="mr-2" data-id="element-653" data-mp="17nlt4g0tuof4">↑</span>
        <Link to="/books" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-654" data-mp="17on82vkyrv24">
          Books
        </Link>
      </li>
      <li className="flex" data-id="element-655" data-mp="35irbm6hk2xmw">
        <span className="mr-2" data-id="element-656" data-mp="35k2f0573a3dh">↑</span>
        <Link to="/workshops" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-657" data-mp="35gy30lndu3c9">
          Workshops
        </Link>
      </li>
      <li className="flex" data-id="element-658" data-mp="3o9s7glndqd28">
        <span className="mr-2" data-id="element-659" data-mp="3o8zaudi4x3xt">↑</span>
        <Link to="/contact" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-660" data-mp="3jafls488vc18">
          Contact
        </Link>
      </li>
    </ul>;
};
export default Navigation;